import { fg } from '@atlaskit/platform-feature-flags';
import { functionWithCondition } from '../function-with-condition';
export var functionWithFG = function functionWithFG(featureFlagName, functionTrue, functionFalse
// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/static-feature-flags
) {
  return functionWithCondition(function () {
    return fg(featureFlagName);
  }, functionTrue, functionFalse);
};